var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFi3388671Hover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_3388671",
    clipPath: "url(#clip0_2040_5434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.8333 3.20833C26.8333 1.43617 25.3972 0 23.625 0H10.2083C8.43617 0 7 1.43617 7 3.20833V18.9583C7 20.7305 8.43617 22.1667 10.2083 22.1667H23.625C25.3972 22.1667 26.8333 20.7305 26.8333 18.9583V3.20833ZM21.2917 16.9167H12.5417C12.0587 16.9167 11.6667 16.5247 11.6667 16.0417C11.6667 15.5587 12.0587 15.1667 12.5417 15.1667H21.2917C21.7747 15.1667 22.1667 15.5587 22.1667 16.0417C22.1667 16.5247 21.7747 16.9167 21.2917 16.9167ZM21.2917 13.4167H12.5417C12.0587 13.4167 11.6667 13.0247 11.6667 12.5417C11.6667 12.0587 12.0587 11.6667 12.5417 11.6667H21.2917C21.7747 11.6667 22.1667 12.0587 22.1667 12.5417C22.1667 13.0247 21.7747 13.4167 21.2917 13.4167ZM21.2917 9.91667H12.5417C12.0587 9.91667 11.6667 9.52467 11.6667 9.04167C11.6667 8.55867 12.0587 8.16667 12.5417 8.16667H21.2917C21.7747 8.16667 22.1667 8.55867 22.1667 9.04167C22.1667 9.52467 21.7747 9.91667 21.2917 9.91667Z",
    fill: "#D42124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.2096 23.9165C7.47497 23.9165 5.2513 21.6917 5.2513 18.9582V3.20817C5.2513 3.10784 5.27464 3.0145 5.28047 2.9165H4.3763C2.60647 2.9165 1.16797 4.355 1.16797 6.12484V24.7915C1.16797 26.5613 2.60647 27.9998 4.3763 27.9998H18.3763C20.1461 27.9998 21.5846 26.5613 21.5846 24.7915V23.9165H10.2096Z",
    fill: "#D42124"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2040_5434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi3388671Hover);
export default __webpack_public_path__ + "static/media/fi_3388671hover.276517c9ee85e3c7916f5a3c671fbdbe.svg";
export { ForwardRef as ReactComponent };